import React, { useEffect, useState, useRef } from 'react'
import { withOidcSecure } from '@axa-fr/react-oidc'
import { useTranslation } from 'react-i18next';
import {useDispatch, useSelector } from 'react-redux';
import HomeLayout from '../../Layout/HomeLayout';
import LeftBar from '../../CustomComponents/DynamicComponent/LeftBar';
import DynamicCard from '../../CustomComponents/DynamicCard';
import FindATM from '../../../assets/images/illo-ATM.png'
import { useLocation, useNavigate } from 'react-router';
import Accordion from '../../CustomComponents/Accordation';
import CustomDropdown from '../../CustomComponents/CustomDropDown';
import CustomTextInput from '../../CustomComponents/CustomtextInput';
import { addLineBreaks, CHECKING, retrieveData } from '../../../utils';
import { width } from '../../CustomComponents/DynamicCard/DynamicCardStyles';
import CustomTextArea from '../../CustomComponents/CustomTextArea';
import Allpoint from '../../../assets/images/allpoint.png';
import Visa from '../../../assets/images/visa.png'
import FooterContent from '../../CustomComponents/Footer';
import Chat from '../../../assets/images/chat.png'
import { ATM_LOCATIONS, PAID_PROMO_KEY } from '../../../network/URLConstants';
import { GetApiHeadersWithBearer, GetRequest } from '../../../network/NetworkUtils';
import { HelpSidebar } from '../../../utils';
import ATMImage from '../../../assets/kudzu-plus-images/ATM.png';
import Loader from '../../CustomComponents/Loader';
import CustomAlertModel from '../../CustomComponents/CustomAlertModel';
import logFirebaseEvents from '../../LogFirebaseEvents';
import { appTheme, showKudzuPlusPrompt } from '../../../helpers/utils/Utils';
import CustomModalPlus from "../../../kudzu_plus/helpers/customModalPlus";
import atmImage from '../../../assets/kudzu-plus-images/ATM.png';
import MemnershipEnrollmentScreens from '../../../kudzu_plus/components/membershipEnrollmentScreens';
import CardHeading from '../../CustomComponents/CardHeading';
import Cookies from 'js-cookie';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';


const ATM = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const currentpath = useLocation()
    const [isLoading, setIsLoading] = useState(false);
    const [headerContenttext, setheaderContent] = useState('');
    const [footerContentText, setfooterContentText] = useState('');
    const [AtmImages, setAtmImages] = useState([]);
    const [showModel, setShowModel] = useState(false);
    const HighlightMsgStyles = "font-serif-pro modal-title text-[var(--modal-text-highlight)] lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal  cursor-pointer pointer-events-none";
    const HeaderMsgStyles = "font-serif-pro text-[var(--modal-text-heading-clr)] modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";
    const SubHeaderMsgStyles = "font-hanken-grotesk text-[var(--modal-text-heading-clr)] modal-title lg:text-[14px] md:text-[13px] sm:text-[11px] text-[12px] font-normal cursor-pointer pointer-events-none";
    const [modelImage, setModelImage] = useState('')
    const [highlightMsg, setHighlightMsg] = useState('')
    const [headerMsg, setheaderMsg] = useState('')
    const [subHeaderMsg, setSubHeaderMsg] = useState('')
    const [btn1Exists, setBtn1Exists] = useState(false)
    const [btn2Exists, setBtn2Exists] = useState(false)
    const [btn1Text, setBtn1Text] = useState(false)
    const [btn2Text, setBtn2Text] = useState('')
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
    const [footerMsg, setFooterMsg] = useState('');
    const [toNavigate, setToNavigate] = useState('');
    const [isBorderNone, setisBorderNone] = useState(true);
    const [showErrorImg, setshowErrorImg] = useState(false);
    const [isFindATMDismissed, setIsFindATMDismissed] = useState(false);
    const smiOneTrue = useSelector((state) => state.smiOneAccountTrue);



    const cards = useSelector(state => JSON.parse(state.userCards));
    const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
    const userLanguage = useSelector(state => state.userLanguage);

    const accessToken = useSelector(state => state.accessToken);
    const initialCards = useRef(cards); // Store initial cards
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const isShowKudzuPlusPrompt = showKudzuPlusPrompt(loggedResponse);
    const [isShowKudzuPlusLearnMore,setIsShowKudzuPlusLearnMore] = useState(false);
    const [showPlusModal, setShowPlusModal] = useState(false);
    const [carousel, setCarousel] = useState('');
    const [btn1BgColor, setBtn1BgColor] = useState("");
    const [summaryParagraph, setSummaryParagraph] = useState('');
    const [opacityValueLow, setOpacityValueLow] = useState(false);
    const [comparisonScreen, setComparisonScreen] = useState('');
    const [fullWidth, setFullWidth] = useState(false);
    const [footerButtonEnable, setFooterButtonEnable] = useState(false);
    const [gradientButton, setGradientButton] = useState(false);
    const [largeImage, setLargeImage] = useState(false);
    const [showCarouselScreenShow, setShowCarouselScreensShow] = useState(false);
    const appThemeData = appTheme(kudzuPlusTrue)
    const [promoKey,setPromoKey] = useState(loggedResponse?.Promos?.[0]?.PromoKey);


    const summaryParagraphStyles = "font-hanken-grotesk modal-title text-white lg:text-[13px] md:text-[10px] sm:text-[6px] text-[8px] font-[200] cursor-pointer pointer-events-none";
    const HeaderMsgStylesForPlus = "font-serif-pro modal-title text-white lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-[400] cursor-pointer pointer-events-none";
    
    useDocumentTitle(t('page_title_find_atm'));

    useEffect(() => {
        if (initialCards?.current?.length > 0) {


            const isPrimrayKey = cards !== null ? cards[0].CardKey : 0;
            const isLanguage = 'en';
            fetchATMs(isPrimrayKey, isLanguage);

        }

    }, []);


    const showAlertModalPlus = (showPlusModal, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, carousel, isBorderNone, btn1BgColor, summaryParagraph, opacityValue, comparisonScreen, fullWidth, footerButtonEnable, gradientButton, largeImage) => {
        setShowPlusModal(showPlusModal)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setBtn1Exists(btn1Exists)
        setBtn1Text(btn1Text)
        setCarousel(carousel)
        setisBorderNone(isBorderNone)
        setBtn1BgColor(btn1BgColor)
        setSummaryParagraph(summaryParagraph)
        setOpacityValueLow(opacityValue)
        setComparisonScreen(comparisonScreen)
        setFullWidth(fullWidth)
        setFooterButtonEnable(footerButtonEnable)
        setGradientButton(gradientButton)// gradient button for popup
        setLargeImage(largeImage)
    }
    const closeModelPlus = () => {
    logFirebaseEvents("Help_Find_An_Atm", "Kudzu_Plus_Closed", "Kudzu_Plus_Closed", "", "");
        setShowPlusModal(false);
        setShowCarouselScreensShow(false);
    }
    const onAcptBtnClickPlusModal = () => {
    logFirebaseEvents("Help_Find_An_Atm", "Kudzu_Plus_Learn_More_Clicked", "Kudzu_Plus_Learn_More_Clicked", "", "");
    setShowPlusModal(false)
    const currentPath = { currentPathFromStore: currentpath.pathname };
    dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
    setShowCarouselScreensShow((prev) => !prev);
    const data = { kudzuFlowFrom: "fromATM" };
    dispatch({ type: 'KUDZU_PLUS_FROM', payload: data })
    }

    const onCancelBtnClickPlusModal = () => {
    logFirebaseEvents("Help_Find_An_Atm", "Kudzu_Plus_No_Thanks_Clicked", "Kudzu_Plus_No_Thanks_Clicked", "", "");
        setShowPlusModal(false)
    }

    const fetchATMs = async (isPrimrayKey, isLanguage) => {
        //   debugger;
        if (cards == undefined || cards == null) {
            return
        }
        setIsLoading(true)
        const deviceId = await retrieveData('updatedDeviceId')
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        const url = ATM_LOCATIONS(isPrimrayKey, isLanguage)
        const response = await GetRequest(url, headers);


        const responseJson = JSON.parse(response);
        setheaderContent(responseJson.Response.Text);
        setfooterContentText(responseJson.Response.Footer);
        setAtmImages(responseJson.Response.Items)
        setIsLoading(false)

    }

    useEffect(() => {
        const FindATMDismisseGet = `FindATMDismiss${cards[0].CardKey}`;
        const FindATMShown = Cookies.get(FindATMDismisseGet); 
        setIsFindATMDismissed(FindATMShown);  
    }, []);
 
    const handleDismiss = () => { 
        const FindATMDismiss = `FindATMDismiss${cards[0].CardKey}`; 
        Cookies.set(FindATMDismiss, 'true', { expires: 1825 });
        setIsFindATMDismissed(true);  
    };

    // const [isLoading, setIsLoading] = useState(false);

    const footerContent = () => {
        return (
            <FooterContent highlightText={addLineBreaks(t("Find_ATM_Footer_Header"))}
                subHeaderText={t("Find_ATM_Footer_Sub_Header_Updated")} 
                image={appThemeData.chatIcon}
                buttonEnabled={true}
                isSubheadingwidth={true}
                isSpace={true}
                type={"helpFooter"}
                buttonText={t("Contact_Us")}
                footerBtnAction={() => { navigate('/Help/ContactUs'); logFirebaseEvents("Find_An_ATM", "Contact_Clicked", "Contact_Clicked", "", "") }} />

        )
    }



    const LearnMoreFooterContent = () => {
        return (
            <FooterContent
                highlightText={(t("Enjoy_Fee-Free"))}
                isShowDismiss={true}
                isSubHeadingMiddla={false}
                isTextWhite={true}
                isHelp={true}
                content ={addLineBreaks(t("Help_Footer_Main_Content"))}
                isShowDismissbackgroundColor={true}
                isContentColor={'#ffffff'}
                isSubHeaderTextSize={'18px'}
                isContentTextSize={'14px'}
                IsContentGap={'pt-5'}
                subHeaderText={(t("Free_out-of-network"))} image={atmImage} type="kudzuPlusLearnMore"
                buttonEnabled={true} buttonText={t("learn_more")} isSpace={false}
                subHeaderTextColor={'#ffffff'} buttonCancelText={t('dismiss')}
                footerBtnActionCancelKudzu={handleDismiss}
                footerBtnAction={() => { 
                    logFirebaseEvents("Help_Find_An_Atm", "Learn_More_Clicked", "Learn_More_Clicked", "", "");
                    dispatch({ type: 'CLIMB_POPUP_SHOWVALUE', payload: { climbPopShowValue: false } });
                    setShowCarouselScreensShow(false);
                   // showAlertModalPlus(true, t("thanks"), t("Try_a_Kudzu+_membership_for_three_months"), "", true, true, t('Learn_More'), t('No_Thanks'), true, require('../../../assets/kudzu-plus-images/KudzuPluseLogo.png'), "", true, "#262B3A", t('first_three_months_charged_automatically'), true, '', false, false, true, true);
                   showAlertModalPlus(true, 
                    promoKey == PAID_PROMO_KEY ? "" : t("thanks"), 
                    promoKey == PAID_PROMO_KEY ? addLineBreaks(t('paid_access_exclusive_fature_and_benfits_when_you_join_kudzu_plus')) :t("Try_a_Kudzu+_membership_for_three_months"), 
                    "", true, true, t('Learn_More'), t('No_Thanks'), true, require('../../../assets/kudzu-plus-images/K-plus-logo.png'), "", true, "#262B3A",
                    promoKey == PAID_PROMO_KEY ?  t('monthly_memebership_fee_will_be_automatically_deducted') : t('first_three_months_charged_automatically'),
                      true, '', false, false, true, true);
                 }} 
                borderDirection={'odd'} />
        )

    }

    // const handleImageClick = (redirectUrl) => {
    //     const confirmRedirect = window.confirm(`This action will redirect you to an external resource.\nDo you want to continue?`);
    //     if (confirmRedirect) {
    //         window.open(redirectUrl, '_blank');
    //     }
    // };
    const handleImageClick = (event, redirectUrl) => {
        logFirebaseEvents("Find_An_ATM", "ATM_Img_Clicked", "ATM_Img_Clicked", "", "")
        if (redirectUrl) {
            event.preventDefault();
            const rawHref = redirectUrl;
            setToNavigate(rawHref.endsWith('.') ? rawHref.slice(0, -1) : rawHref)
            showAlertModal(true, t("heads_up"), smiOneTrue ? t("Youre_about_to_leave_the") : t("about_to_leave_kudzu"), t("redirected_from_kudzu"), true, true, t("continue"), t("cancel"), true, '', false, false);
        }

    };
    const closeCustomAlertModal = () => {
        logFirebaseEvents("Find_An_ATM", "Cancel_Clicked", "Cancel_Clicked", "", "")
        setShowModel(false);
    }
    const onAcptBtnClick = async () => {
        logFirebaseEvents("Find_An_ATM", "Continue_Clicked", "Continue_Clicked", "", "")
        if (headerMsg == t('about_to_leave_kudzu')) { window.open(toNavigate, '_blank'); closeCustomAlertModal(); setToNavigate('') }
    }
    const onCancelBtnClick = () => {

        if (headerMsg == t('about_to_leave_kudzu')) { closeCustomAlertModal(); setToNavigate('') }
    }
    const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, showErrorImg, isBorderNone) => {
        setshowErrorImg(showErrorImg)
        setisBorderNone(isBorderNone)
        setShowModel(showModel)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
    }

    return (
        <>
            <HomeLayout>
                <HelpSidebar HelpselectedIndex={3} />
                {showCarouselScreenShow && 
             <MemnershipEnrollmentScreens/> }

                <div className='md:w-[150px] sm:w-[70px] w-[0px]'></div>
                <div className='flex flex-col md:w-[860px] sm:w-[464px] 
            w-[100%] animate__animated animate__fadeInRight '>
                    <DynamicCard
                        header={false}
                        CardRadius={true}
                        cardWidth={width.homeCard}
                        HeaderRadius={true}
                        isWhite={appThemeData.isWhiteBgForCard}
                        isDarkForKudzu={appThemeData.isDarkBgForCard}
                        backgroundColor={'--cardHeading-bg'} 
                        HeaderContent={
                            <>
                                <CardHeading heading={t('find_ATM')} />
                            </>
                        }
                    >
                        <div className='w-full'>
                            {/* <div className="lg:my-[2rem] md:my-[1.5rem] my-[1.5rem] font-[500] md:font-[500] sm:font-[600] 
                       lg:text-[26px] md:text-[22px] 
                       sm:text-[15px] text-[20px] leading-[36px] font-hanken-grotesk 
                        sm:mx-0 mx-4">
                                {(t('find_ATM'))}
                            </div> */}

                            <div className={`${kudzuPlusTrue ? '' : ' border-t-[2.5px] border-[#A3CEBB]'} sm:mx-0 mx-4`}>
                            </div>

                            <div className='flex-col justify-center sm:mx-0 mx-4'>
                                <div className='w-full flex justify-center'>
                                    <div className='sm:w-[70%] text-[var(--text-clr-transactions)] md:w-[70%] w-full lg:my-16 md:my-12 sm:my-10 my-10 md:text-[18px] md:leading-[28px]
                                     sm:text-[10px] sm:leading-[16px] text-[16px] leading-[24px] font-hanken-grotesk font-[500]'
                                        dangerouslySetInnerHTML={{ __html: headerContenttext?.replace('<br/>', '<br/><br/>') }} >
                                    </div>
                                </div>
                            </div>

                            <div className='w-full flex flex-row  justify-center
                             gap-5 items-center lg:py-10 py-0'>
                                {AtmImages.map(item => (
                                    <div key={item.Name} style={{ cursor: 'pointer' }}>
                                        <img className='md:w-[158.99px] md:h-[100px] 
                                        sm:w-[124px] sm:h-[80px] w-[124px] h-[80px]'
                                            src={item.ImageUrl}
                                            alt={item.Name}
                                            onClick={(event) => handleImageClick(event, item.RedirectUrl)}
                                        />
                                    </div>
                                ))}
                            </div>
                            <div className='flex-col justify-center sm:mx-0 mx-4'>
                                <div className='w-full flex justify-center'>
                                    <div className='sm:w-[70%] md:w-[70%] w-full my-16 sm:my-12 md:my-16 pb-6'>
                                        <p dangerouslySetInnerHTML={{ __html: footerContentText }}
                                            className='md:text-[12px] sm:text-[10px] text-[12px] md:leading-[18px] sm:leading-[16px] text-[var(--text-clr-transactions)] leading-[18px] font-[600] font-hanken-grotesk sm:font-[500] md:font-[600] uppercase md: tracking-wide sm:tracking-wider'></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </DynamicCard>
                    {footerContent()}
                    {(!kudzuPlusTrue && isShowKudzuPlusPrompt && !isFindATMDismissed) && LearnMoreFooterContent()}
 
                </div>
            </HomeLayout >
            <CustomModalPlus isOpen={showPlusModal} onClose={closeModelPlus}
                image={modelImage}
                carousel={carousel}
                summaryParagraph={<p className={summaryParagraphStyles}>{summaryParagraph}</p>}
                isBorderNone={isBorderNone}
                highlightMsg={<p className={HeaderMsgStylesForPlus}> {headerMsg}</p>}
                subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text}
                btn1BgColor={btn1BgColor}
                btn2Text={btn2Text}
                opacityLow={opacityValueLow}
                defaultCornerRadius={false}
                btn1TypeAcpt={btn1TypeAcpt}
                onAcptBtnClick={onAcptBtnClickPlusModal}
                onCancelBtnClick={onCancelBtnClickPlusModal}
                gradientButton={gradientButton}
                largeImage={largeImage}
                kudzuPlusTrue={kudzuPlusTrue}
                btn2TextColor={'#779CE5'}

            />
            <CustomAlertModel isOpen={showModel}
                Fullheight={true}
                onClose={closeCustomAlertModal}
                image={modelImage}
                highlightMsg={<p className={HighlightMsgStyles}>{highlightMsg}</p>}
                HeaderMsg={<p className={HeaderMsgStyles}>{headerMsg}</p>}
                subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text} btn2Text={btn2Text}
                btn1TypeAcpt={btn1TypeAcpt}
                verificationFailure={() => { }}
                footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
                onAcptBtnClick={onAcptBtnClick}
                onCancelBtnClick={onCancelBtnClick}
                showErrorImg={showErrorImg}
                isBorderNone={isBorderNone}
                kudzuPlusTrue={kudzuPlusTrue}
            />
            {isLoading && <Loader />}
        </>

    )
}

export default withOidcSecure(ATM)